module.exports = __webpack_public_path__ + "img/pic_login.fbde9136.png";